var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "bg-white shadow py-5 px-3 mb-4" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "1" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Buscar",
                  expression: "'Buscar'"
                }
              ],
              staticClass: "btn-icon rounded-circle p-3",
              attrs: { variant: "primary", size: "sm" },
              on: {
                click: function($event) {
                  return _vm.appliFilters()
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
            1
          )
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-lg": 11 } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.filtros.id.value,
              expression: "filtros.id.value"
            }
          ],
          staticClass: "form-control",
          attrs: { placeholder: "Buscar", "data-cy": "search" },
          domProps: { value: _vm.filtros.id.value },
          on: {
            keypress: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.appliFilters($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.filtros.id, "value", $event.target.value)
            }
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }